export const secondaryButtonProps = {
    text: true,
    class: 'error--text px-8',
}
